<div [ngSwitch]="currentView">
    <div *ngSwitchCase="carouselType.BASIC">
        <div class="kamona-swiper-container">
            <swiper-container #kamonaSwiper [autoplay]="{
      delay: autoplay,
      disableOnInteraction: false
    }"
                    [navigation]="false"
                    [pagination]="{
            dynamicBullets: true
          }"
                    [slidesPerView]="slidesPerView"

                    [spaceBetween]="spaceBetween" class="mySwiper">
                <swiper-slide *ngFor="let item of carouselItems; index as i" swiperSlide>
                    <ng-container [ngTemplateOutletContext]="{ $implicit: item, idx: i }"
                                  [ngTemplateOutlet]="carouselTemplateRef">
                    </ng-container>
                </swiper-slide>
                <ng-template *ngIf="enableTouchSwipe" swiperSlide>
                </ng-template>
            </swiper-container>
        </div>
    </div>
</div>
